var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgByFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5627 1.6665H4.97933C4.54283 1.6665 4.1242 1.8421 3.81555 2.15466C3.5069 2.46722 3.3335 2.89114 3.3335 3.33317V16.6665C3.3335 17.1085 3.5069 17.5325 3.81555 17.845C4.1242 18.1576 4.54283 18.3332 4.97933 18.3332H14.8543C15.2908 18.3332 15.7095 18.1576 16.0181 17.845C16.3268 17.5325 16.5002 17.1085 16.5002 16.6665V6.6665L11.5627 1.6665Z",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 1.6665V6.6665H16.5",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByFile);
export default __webpack_public_path__ + "static/media/ByFile.9726c7408e5ba47ebc5d30e1038a81be.svg";
export { ForwardRef as ReactComponent };